module.exports = __webpack_public_path__ + "static/media/3DRM.c67e42a9.png";